import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    items: null,
    materiais: null,
    servicos: null,
    materiaisOs: null,
    fields: null,
    dadosTable: null,
    tabelas: null,
    tabelasFiltro: null,
    totalPage: null,
    fromPage: null,
    toPage: null,
    bases: null,
    parametro_preditiva: null
  },

  getters: {
    items: (state) => state.items,
    materiais: (state) => state.materiais,
    servicos: (state) => state.servicos,
    materiaisOs: (state) => state.materiaisOs,
    getFields: (state) => state.fields,
    getDadosTable: (state) => state.dadosTable,
    getTabelas: (state) => state.tabelas,
    getTabelasFiltro: (state) =>state.tabelasFiltro,
    getTotalPage: (state) => state.totalPage,
    getFromPage: (state) => state.fromPage,
    getToPage: (state) => state.toPage,
    getBases: (state) => state.bases,
    getParametroPreditiva: (state) => state.parametro_preditiva,
  },

  actions: {
    async executarScriptBase({ commit }, { data }) {
      try {
        const response = await api.post('/submitScriptBase', { ...data })

        return response
      } catch (error) {
         // Exibe a parte específica do erro

        return error
        // throw new Error(error)
      }
    },

    async selectBases({ commit }, { data }) {
      try {
        const tabelas = await api.post('/selectBases', { ...data });

        let tabelasFiltradas = ''

        if(data.tp_base == 'T'){
          tabelasFiltradas = tabelas.data.tabelas.filter(item => typeof item.name === 'string' && item.name.startsWith("csv_"))
        } else if(data.tp_base == 'I') {
          tabelasFiltradas = tabelas.data.tabelas
        } else {
          tabelasFiltradas = tabelas.data.tabelas.filter(item => typeof item.name === 'string' && item.name.startsWith("3xdata"))
        }

        commit('setBases', tabelasFiltradas)

        return tabelasFiltradas
      } catch (error) {
        throw new Error(error)
      }
    },
    
    async pesquisarTabela({ commit, state }, { tabela }) {
      try {
        const tabelasFiltradas = state.tabelas.filter(nomeTabela => nomeTabela.table_name.includes(tabela));

        commit('setTablesFiltro', tabelasFiltradas)
      } catch (error) {
        throw new Error(error)
      }
    },

    async executarScript({ commit }, { data }){
      try {
        const response = await api.post('frota/executarScript', { ...data })

        commit('setItemsTable', response.data.dados)
        commit('setFields', response.data.fields)
        commit('setTables', response.data.tabelas)


        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchMateriaisOs({ commit }, { data }) {
      try {
        const response = await api.post('frota/materiaisOs', { ...data })

        commit('setMateriaisOs', response.data)
        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async deletePeca ({ commit }, { data }) {
      try {
        const response = await api.post(`frota/deletePeca`, { ...data })

        return response
      } catch (error) {
        throw new Error (error)
      }
    },

    async fetchFromApi ({ commit }, { params }) {
      try {
        const response = await api.get('frota/itens', { params: { ...params } })
        
        commit('setItems', response.data.items)
        commit('setPreditiva', response.data.preditiva_item)
        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchFromMateriais ({ commit }, { data }) {
      try {
        const response = await api.post(`frota/materiais`, { ...data })

        commit('setMateriais', response.data) 
        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchFromServicos ({ commit }, { data }) {
      try {
        const response = await api.post(`frota/materiais`, { ...data })

        commit('setServicos', response.data) 
        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    async getTable({ commit }, { data }) {
      try {
        const response = await api.post('frota/getTable?page=' + data.current_page, { ...data })

        commit('setContadores', { total: response.data.dados.total, from: response.data.dados.from, to: response.data.dados.to })
        commit('setItemsTable', response.data.dados.data)
        commit('setFields', response.data.fields)
        commit('setTables', response.data.tabelas)

        return response
      } catch (error) {
        throw new Error(error)
      }
    },
  },

  mutations: {
    setBases(state, bases) {
      state.bases = bases
    },
    setPreditiva(state, preditiva) {
      state.parametro_preditiva = preditiva
    },

    setContadores(state,{ total, from, to } ) {
      state.totalPage = total
      state.fromPage = from
      state.toPage = to
    },
    setItems (state, items) {
      state.items = items
    },
    setServicos (state, items) {
      state.servicos = items
    },
    setMateriais (state, items) {
      state.materiais = items
    },
    setMateriaisOs (state, items) {
      state.materiaisOs = items
    },

    setFields(state, fields) {
      state.fields = fields
    },

    setItemsTable(state, dadosTable) {
      state.dadosTable = dadosTable
    },

    setTables(state, tables) {
      state.tabelas = tables
      state.tabelasFiltro = tables
    },
    
    setTablesFiltro(state, tables) {
      state.tabelasFiltro = tables
    }
  }
}
